import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Platform } from '@ionic/angular';

import { AuthService } from './auth/auth.service';
import { ApiService } from './api.service';
import { AppService } from './app.service';

export const authGuard: CanActivateFn = async (): Promise<boolean> => {
  const platform = inject(Platform);
  const api = inject(ApiService);
  const auth = inject(AuthService);
  const app = inject(AppService);

  if (app.authReady) return true;

  //
  // HELPERS
  //

  const doAuth = async (): Promise<void> => {
    const res = await auth.isAuthenticated();
    api.authToken = res.token;
    app.user = res.user;
  };

  //
  // MAIN
  //

  await platform.ready();

  try {
    await doAuth();
  } catch (err) {
    app.user = null;

    if (app.fromDeepLink) return;
    else app.goTo(['auth'], { root: true });
  } finally {
    app.authReady = true;
    return true;
  }
};
